import { Box, Card, CardContent, Grid, Skeleton } from "@mui/material";


const ConfidenceIntervalCardSkeleton = () => {
  return (
    <Card className="w-full mt-2 mb-2">
      <CardContent>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, sm: 12, md: 3 }}>
            <Grid
              container
              spacing={2}
              justifyContent="left"
              className="font-bold pt-2"
            >
              <Skeleton variant="text" width="50%" />
            </Grid>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 9 }}>
            <Box className="flex items-center justify-end gap-4 w-full">              
              <Skeleton variant="text" width="25%" />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ConfidenceIntervalCardSkeleton;
